import { RolePermission, RolePermissionService, RoleService } from "@nt-portal/server-sdk";
import { ControllerOptions, DataController } from "../../../types";
import { BaseClientService } from "../base-client.service";
import { initRole } from "./roles.service";
import { ResultData } from "@nt-portal/common-sdk";


export interface RolePermissionsOptions extends ControllerOptions<RolePermission> {

}


export const initRolePermission = () => {
    let item: RolePermission = {
        id: '', role: initRole(), permission: 'view', module: "", createdBy: ""
    }
    return item;
}

export class ClientRolePermissionService extends BaseClientService implements DataController<RolePermission> {

    private _service: RolePermissionService;


    constructor() {
        super();
        this._service = new RolePermissionService({
            apiService: this.apiService,
            url: this.settings.fabrixServer
        });
    }
    
   public async get(options: RolePermissionsOptions): Promise<ResultData<RolePermission>> {

        return await this._service.get(this.buildFetchParams(options), this.token);
       
    }
    public async getLookup(options: RolePermissionsOptions): Promise<ResultData<RolePermission>> {
        let fetchParams = this.buildLookupFetchParams(options);
        let data = await this._service.get(fetchParams, this.token);
        return data;
    }

    public async getById(options: RolePermissionsOptions): Promise<RolePermission | null> {
        if (options.id) {
            let item = await this._service.getById(options.id, this.token);
            return item;
        }
        return null;
    }
    public async delete(options: RolePermissionsOptions): Promise<any> {
        if (options.id)
            await this._service.delete(options.id, this.token);
    }
    public async update(options: RolePermissionsOptions): Promise<RolePermission | RolePermission[] | null> {
        if (options.item )
            return await this._service.update(options.item, this.token)
        return null;
    }
    public async add(options: RolePermissionsOptions): Promise<RolePermission | RolePermission[] | null> {
        if (options.item )
            return await this._service.add(options.item, this.token)
        return null;
    }
   


}